import { createRouter, createWebHistory } from "vue-router";
import HomePage from "@/views/HomePage.vue";
import TourPage from "@/views/TourPage.vue";
import MerchPage from "@/views/MerchPage.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: HomePage,
  },
  {
    path: "/tour",
    name: "Tour",
    component: TourPage,
  },
  {
    path: "/merch",
    name: "Merch",
    component: MerchPage,
  },
];

// github pages routing workaround
const params = new URLSearchParams(window.location.search)
const redirected = params.get('p')

if (redirected && redirected !== window.location.pathname) {
  window.history.replaceState({}, '', redirected)
}

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;

